import { AxiosInstance } from 'axios';
import { createApiClient } from './http/client';
import { ClinicConfig, LeadAndProvider } from '../interfaces/onboarding';

const ONBOARDING_BASE_URL = process.env.REACT_APP_PUBLIC_ONBOARDING_BASE_URL ?? '';

class OnboardingClient {
  private axios: AxiosInstance;

  constructor() {
    this.axios = createApiClient({
      baseURL: ONBOARDING_BASE_URL ?? '',
    });
  }

  public async createLead(lead: LeadAndProvider): Promise<boolean> {
    try {
      const response = await this.axios.post<{ success: boolean }>(
        '/onboarding/v2.0/crm/leads',
        lead,
      );

      return !!response.data.success;
    } catch (error) {
      console.error(error);
      return false;
    }
  }

  public async getClinicConfig(clinicId: number): Promise<ClinicConfig | null> {
    try {
      const response = await this.axios.get<{ success: boolean; clinic: ClinicConfig | null }>(
        `/v2.0/clinics/${clinicId}/config`,
      );

      if (!response || !response.data.success) {
        return null;
      }

      return response.data.clinic;
    } catch (error) {
      console.error(error);
      return null;
    }
  }
}

const onboardingService = new OnboardingClient();

export default onboardingService;
